import { PropsWithChildren, useState } from 'react'

import { Worker } from 'twilio-taskrouter'

import { TwilioWorkerContext } from './TwilioWorkerContext'

export function TwilioWorkerProvider({ children }: PropsWithChildren) {
  const [worker, setWorker] = useState<Worker | null>(null)

  return (
    <TwilioWorkerContext.Provider value={{ worker, setWorker }}>
      {children}
    </TwilioWorkerContext.Provider>
  )
}
